import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { Action, combineReducers } from 'redux'

import {
  fetchChangeLog,
  updateVersion,
} from 'apps/applications/actions/installedApplicationsActions'
import * as actionTypes from 'apps/applications/constants/InstalledApplicationsReduxActionTypes'
import { UpdateStage, ChangelogState } from 'common/actions/integrations/Applications/interfaces'

interface IActionWithApplicationId extends Action {
  applicationId: number
}

const stageReducer = (
  state = UpdateStage.Changelog,
  action: Action | (Action & { stage: UpdateStage }),
): UpdateStage => {
  switch (action.type) {
    case actionTypes.APPLICATION_VERSION_UPDATE_STAGE_SET:
      if ('stage' in action) {
        state = action.stage
      }
      break
    case actionTypes.APPLICATION_UPDATE_MODAL_CLOSE:
      state = UpdateStage.Changelog
  }

  return state
}

const changelogInitialState: ChangelogState = {
  fetching: false,
  changelogs: [],
}

const changelogSlice = createSlice({
  name: 'changelog',
  initialState: changelogInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChangeLog.pending, (state) => {
        state.fetching = true
        state.changelogs = []
      })
      .addCase(fetchChangeLog.fulfilled, (state, action) => {
        state.fetching = false
        state.changelogs = action.payload ?? []
      })
      .addCase(fetchChangeLog.rejected, (state) => {
        state.fetching = false
        state.changelogs = []
      })
      .addCase(actionTypes.APPLICATION_UPDATE_MODAL_CLOSE, (state) => {
        state.fetching = false
        state.changelogs = []
      })
  },
})

const changelogReducer = changelogSlice.reducer

const applicationIdReducer = (
  state: number | null = null,
  action: Action | IActionWithApplicationId,
): number | null => {
  switch (action.type) {
    case actionTypes.APPLICATION_UPDATE_MODAL_OPEN:
      if ('applicationId' in action) {
        state = action.applicationId
      }
      break
    case actionTypes.APPLICATION_UPDATE_MODAL_CLOSE:
      state = null
      break
  }

  return state
}

const updateFetchingSlice = createSlice({
  name: 'updateFetching',
  initialState: false,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateVersion.pending, () => {
        return true
      })
      .addMatcher(isAnyOf(updateVersion.fulfilled, updateVersion.rejected), () => {
        return false
      })
  },
})

const updateFetchingReducer = updateFetchingSlice.reducer

export default combineReducers({
  applicationId: applicationIdReducer,
  changelog: changelogReducer,
  stage: stageReducer,
  updateFetching: updateFetchingReducer,
})
